import apple from './apple.svg'
import facebook from './facebook.svg'
import google from './google.svg'
import kakao from './kakao.svg'
import line from './line.svg'
import only_icon_apple from './only_icon_apple.svg'
import only_icon_facebook from './only_icon_facebook.svg'
import only_icon_google from './only_icon_google.svg'

export const icon: Record<string, any> = {
  apple,
  facebook,
  google,
  kakao,
  line,
  only_icon_apple,
  only_icon_facebook,
  only_icon_google,
}
